export const PDFPaperSize = {
  Landscape: 'Landscape',
  Portrait: 'Portrait',
};
export const addressKeys = ['address1', 'city', 'state', 'postalCode', 'stateProvince'];
export const PropertyTypes = {
  Office: 'Office',
  Industrial: 'Industrial',
  Retail: 'Retail',
};

// eslint-disable-next-line no-shadow
export enum MediaFileType {
  images = 'IMAGES',
  fliers = 'FLIERS',
  floorplans = 'FLOORPLANS'
}

export const MediaOverlayMap: StringKeyValue = {
  FLIERS: 'Flyer',
  FLOORPLANS: 'Floorplan',
};
export type StringKeyValue = {
  [key: string]: string;
};

export const linkAttributes = ['Website', 'Virtual Tour', 'Google Maps Link', 'Links', 'Location Link'];
export const linkAttributes_UK_Regional = ['Global Listings'];
export const Measurement = ['Measurements'];

export const linkAttributes_pac = ['Website', 'Virtual Tour', 'Inspace URL', 'Video URL and all other links', 'All Other Links'];

// Countries that require CE-specific link field rendering and industrial property handling
export const CE_LINK_COUNTRIES = ['Spain', 'Germany'];

export const AVAILABILITY_NAME_KEY = 'availabilityName';

export const MULTI_FLOOR_SUITE_FIELD = 'availability_info_floor_details';

export const SpecificationAmenitiesAttributes = ['Specification and Amenities'];

export const VIEW_MODE = {
  PROPERTY: 'property',
  AVAILABILITY: 'availability',
} as const;
